import { render, staticRenderFns } from "./seeCupons.vue?vue&type=template&id=4c0c2b0d"
import script from "./seeCupons.vue?vue&type=script&lang=js"
export * from "./seeCupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports